export default "__VITE_ASSET__d8VGAW_0__"